import { render, staticRenderFns } from "./PaymentTemplate.vue?vue&type=template&id=6ef9d44c&scoped=true"
import script from "./PaymentTemplate.vue?vue&type=script&lang=js"
export * from "./PaymentTemplate.vue?vue&type=script&lang=js"
import style0 from "./PaymentTemplate.vue?vue&type=style&index=0&id=6ef9d44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef9d44c",
  null
  
)

export default component.exports